import type { CampaignTemplateCreateRequestProgramType } from "generated/schemas";

import type { OptionType } from "ui/select";
import type { CampaignTemplateProgram } from "containers/admin/clients/client/campaign-templates-page/campaign-templates-page.types";

export type ProgramTypeOption = OptionType & { value: CampaignTemplateCreateRequestProgramType };

export const PROGRAM_TYPE_OPTIONS: ProgramTypeOption[] = [
  { label: "Aware to apply", value: "AWARE_TO_APPLY" },
  { label: "Admit to enroll", value: "ADMIT_TO_ENROLL" },
  { label: "Pre-college", value: "PRE_COLLEGE" },
];

const formatEnumLabel = (value: string) =>
  value
    .toLowerCase()
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

export const getProgramTypeLabel = (program: CampaignTemplateProgram) =>
  PROGRAM_TYPE_OPTIONS.find((option) => option.value === program)?.label ?? formatEnumLabel(program);

export const PROGRAM_TYPE_FILTER_OPTIONS = PROGRAM_TYPE_OPTIONS.map((opt) => ({
  name: opt.value,
  description: opt.label as string,
}));

/** Keep in sync with `CampaignTemplateSchemaService.getLatestVersion()` on the backend. */
export const LATEST_CAMPAIGN_TEMPLATE_SCHEMA_VERSION = 7;
